<template>
	<div>
		<h3>退单记录</h3>
		<div class="searchBox">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item label="时间范围">
					<el-date-picker v-model="formInline.time" type="daterange" align="right" unlink-panels range-separator="至"
					 start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" @change='changeTime'>
					</el-date-picker>
				</el-form-item>
<!-- 				<el-form-item label="关键字">
					<el-input v-model="formInline.hit" placeholder="关键字"></el-input>
				</el-form-item> -->
				<el-button class="text2 " type="primary" @click='indexPage=0;currentPage=1;getData();'>查询</el-button>
			</el-form>
		</div>
		<div class="table">
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"  height='calc(100vh - 310px)'>
				<el-table-column label="出单时间">
					<template slot-scope="scope">
						<span>{{setTime(scope.row.createAt)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="姓名">
					<template slot-scope="scope">
						<span>{{scope.row.name || '--'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="手机号">
					<template slot-scope="scope">
						<span>{{scope.row.mobileno || '--'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="证件">
					<template slot-scope="scope">
						<span>{{scope.row.nationalId || '--'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="付款金额">
					<template slot-scope="scope">
						<span class="yellow">￥{{scope.row.amount/100}}元</span>
					</template>
				</el-table-column>
				<el-table-column prop="billingState" label="退单状态">
					<template slot-scope="scope">
						<span class="blue">{{billingState[scope.row.billingState]}}</span>
					</template>
				</el-table-column>
				<el-table-column label="兑换卡号" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{scope.row.code || '--'}}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			 :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
			 :total="allpage">
			</el-pagination>
		</div>			
	</div>
</template>

<script>
	import { refundListExit } from '@/axios/api.js'
	import common from '@/assets/common.js'
	export default {
		data() {
			return {
				formInline: {
					hit: '',
					time: '',
					startts:'0',
					endts:'',
					start:0,
					count:100
				},
				billingState:['创建','线上支付完成','挂帐月结-未付','线下转账-已付款','已退单','投保失败退单','投保失败退单'],
				pickerOptions2: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				tableData: [],
				allpage:0,//数据总数
				eachPage:10,//每页
				indexPage:0,//当前页	
        currentPage:1,				
			}
		},
		methods: {
			setTime(str) {
				return common.time(str)
			},			
			handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.getData()
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
        this.currentPage = val;
				this.indexPage = (val-1) * this.eachPage;
				console.log(val)
				this.getData()
			},	
			getData(){
				var time=(new Date()).getTime()
				if(this.formInline.endts == ''){
					this.formInline.endts=time
				}
				this.formInline.start=this.indexPage;
				this.formInline.count=this.eachPage;
					count:this.eachPage,
				refundListExit(this.formInline)
				.then(res => {
					this.tableData=res.data.obj;
					this.allpage=res.data.total;				
				})
				.catch(err => {
					console.log(err)
				})
			},
			changeTime(){	
				if(this.formInline.time){
					this.formInline.startts=this.formInline.time[0].getTime()
					this.formInline.endts=this.formInline.time[1].getTime()+86399000//23时59分59秒
				}else{
					this.formInline.startts=0
					this.formInline.endts=''
				}
			}			
		},
		mounted(){
			this.getData()
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}

	.el-range-separator {
		width: 20px !important;
	}
</style>
<style scoped="scoped">
	h3 {
		margin: 20px 0;
		font-weight: normal;
	}

	.searchBox {
		margin-top: 20px;
	}
	.text{margin-top: 20px;}
	.fenye {
		margin-top: 20px;
		overflow: hidden;
	}
	.fenye .pagination {
		float: right;
	}		
</style>



// WEBPACK FOOTER //
// src/views/financial/exit.vue